module.exports = __webpack_public_path__ + "img/banner-right.0218ff23.png";